import { Component, ViewEncapsulation, HostListener, Input } from '@angular/core';
import { PanelItem } from '../panel-item';

@Component({
  selector: 'top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TopNavComponent {
  @Input() panelItems: PanelItem[] = [];

  isOpen = false;

  onNavigationButtonClick() {
    this.isOpen = !this.isOpen;
  }

  // Update the active section
  setActive(item: PanelItem): void {
    this.panelItems.forEach(x => x.isActive = (x.id === item.id));
  }

  // Handle the scroll event to fix the top navigation bar on the screen when scrolled down
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const header = document.getElementById('top-nav');
    if (header) {
      const headerBottom = header.getBoundingClientRect().top;
      const isFixed = headerBottom <= 0; 

      // Fix navigation when header scrolls out of view
      if (isFixed) {
        header.setAttribute('stuck', '');
      } else {
        header.removeAttribute('stuck');
      }
    }
  }
}
